import { render, staticRenderFns } from "./questionBody.vue?vue&type=template&id=11b0a75e&"
import script from "./questionBody.vue?vue&type=script&lang=js&"
export * from "./questionBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/common/questionBody.vue"
export default component.exports